export enum TablesEnum {
  ClientCaseTable = 'clientCaseTable',
  ClientTable = 'clientTable',
  CompanyTable = 'companyTable',
  ImportTable = 'importTable',
  LeadCaseTable = 'leadCaseTable',
  LenderTable = 'lenderTable',
  LenderGroupTable = 'lenderGroupTable',
  NetworkTable = 'networkTable',
  MortgageClosedCaseTable = 'mortgageClosedCaseTable',
  MortgageDocAiTable = 'mortgageDocAiTable',
  MortgagePipelineCaseTable = 'mortgagePipelineCaseTable',
  MortgageTable = 'mortgageTable',
  OpportunityApprovalRequiredTable = 'opportunityApprovalRequiredTable',
  OpportunityTable = 'opportunityTable',
  OutcodeToRegionTable = 'outcodeToRegionTable',
  PreCompletionTable = 'preCompletionTable',
  ReferralCodeTable = 'referralCodeTable',
  TinyUrlsTable = 'tinyUrlsTable',
  UserTable = 'userTable',
  AffiliateTable = 'affiliateTable',
  PropertyTable = 'propertyTable',
  MortgageProductTable = 'mortgageProductTable',
  ClientActivityLogTable = 'clientActivityLogTable',
}
